import { useState } from 'react';

import React from "react";
//import "./_group_management_header.css";

export default function GroupManagementHeader({
  title,
  editingTitle,
  setEditingTitle,
  saveTitle,
  handleTitleChange,
  userCanEdit,
}) {
  return (
    <header className="gmh-header">
      {editingTitle !== false ? (
        <input
          onKeyPress={(e) => {
            if (e.key === "Enter") saveTitle(e);
          }}
          value={editingTitle !== false ? editingTitle : title}
          onChange={handleTitleChange}
          onBlur={saveTitle}
          className="gmh-input"
          autoFocus
        />
      ) : (
        <>
          <h1
            className={`gmh-title${userCanEdit ? " editable" : ""}`}
            onClick={() => userCanEdit && setEditingTitle(title)}
          >
            {title}
          </h1>

          {!userCanEdit && (
            <div className="gmh-warning">
              Insufficient edit permissions.
            </div>
          )}
        </>
      )}
    </header>
  );
}


/*
export default function GroupManagementHeader({
  title,
  editingTitle,
  setEditingTitle,
  saveTitle,
  handleTitleChange,
  userCanEdit,
}){
  return (

    <header className="mb-3 justify-between">
      {editingTitle!==false ? (
        <input
          onKeyPress={e => {
            if( e.key === 'Enter' ){
              saveTitle(e);
            }
          }}
          value={editingTitle!==false?editingTitle:title}
          onChange={handleTitleChange}
          onBlur={saveTitle}
          className="text-2xl font-semibold border-b border-gray-300 focus:outline-none focus:border-blue-400 bg-transparent"
          autoFocus
        />
      ) : (
        <>
          <h1
            className={"text-2xl font-semibold" + (userCanEdit ? " cursor-text hover:bg-gray-100 " : "") +" px-1 rounded"}
            onClick={() => userCanEdit && setEditingTitle(title)}
          >
            {title}
          </h1>
          {!userCanEdit && (
            <div class="text-sm font-medium text-red-700 bg-red-50 border border-red-200 px-2 py-1 rounded">
              Insufficient edit permissions.
            </div>
          )}

        </>

      )}


    </header>

  )
}
*/
/*
export default function GroupManagementHeader({
  title,
  editingTitle,
  setEditingTitle,
  saveTitle,
  handleTitleChange,
  userCanEdit,
}) {
  const styles = {
    header: {
      marginBottom: 12, // mb-3
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
    },
    input: {
      fontSize: 24, // text-2xl
      fontWeight: 600,
      borderBottom: "1px solid #D1D5DB", // gray-300
      outline: "none",
      background: "transparent",
      width: "100%",
      padding: "2px 4px",
    },
    inputFocus: {
      //borderBottom: "1px solid #60A5FA", // blue-400
      border:'1px solid #ccc',
    },
    title: (canEdit, isHover) => ({
      fontSize: 24,
      fontWeight: 600,
      padding: "0 4px",
      borderRadius: 4,
      cursor: canEdit ? "text" : "default",
      background: canEdit && isHover ? "#F3F4F6" : "transparent", // gray-100
      transition: "background 0.15s ease",
    }),
    warning: {
      fontSize: 14,
      fontWeight: 500,
      color: "#B91C1C", // red-700
      background: "#FEF2F2", // red-50
      border: "1px solid #FECACA", // red-200
      padding: "4px 8px",
      borderRadius: 6,
      marginTop: 4,
    },
  };

  const [hover, setHover] = useState(false);

  return (
    <header style={styles.header}>
      {editingTitle !== false ? (
        <input
          onKeyPress={(e) => {
            if (e.key === "Enter") saveTitle(e);
          }}
          value={editingTitle !== false ? editingTitle : title}
          onChange={handleTitleChange}
          onBlur={saveTitle}
          style={{ ...styles.input }}
          autoFocus
        />
      ) : (
        <>
          <h1
            style={styles.title(userCanEdit, hover)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => userCanEdit && setEditingTitle(title)}
          >
            {title}
          </h1>

          {!userCanEdit && (
            <div style={styles.warning}>
              Insufficient edit permissions.
            </div>
          )}
        </>
      )}
    </header>
  );
}
*/
